import { t } from 'i18next';

import { SelectionBase } from './SelectionBase';
import { SelectBoxOption } from '../stores/SelectBoxStore';
import { PconLoginStore } from '../stores/PconLoginStore';
import { ProjectSettingsStore } from '../stores/ProjectSettingsStore';
import { ProjectSettingsActions } from '../actions/ProjectSettingsActions';

export class SelectionPrice extends SelectionBase {
    protected id: string = 'price-select';

    public componentWillMount(): void {
        this.addStoreListener(PconLoginStore, this.onChange);
        this.addStoreListener(ProjectSettingsStore, this.onChange);
        this.onChange();
    }

    protected onChange = (): void => {
        this.setState({
            value: ProjectSettingsStore.getState().articleListPrices,
            visible: PconLoginStore.pricesEnabled(),
            enabled: true
        });
    };

    protected getLabel(): string {
        return t('Article List');
    }

    protected options(): Array<SelectBoxOption> {
        return [
            {
                name: t('Show prices'),
                className: 'egr-select-option-noicon',
                value: 'show',
                callback: () => { ProjectSettingsActions.setArticlePriceVisibility(true); }
            },
            {
                name: t('Hide prices'),
                className: 'egr-select-option-noicon',
                value: 'hide',
                callback: () => { ProjectSettingsActions.setArticlePriceVisibility(false); }
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SelectionPrice.tsx